/* eslint-disable @typescript-eslint/no-magic-numbers */
import type { SigningFeatureConfig } from './type';

export const signing: Partial<SigningFeatureConfig> = {
    otpLengths: [4],
};
